import { Card, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import { GrView } from "react-icons/gr";
import PageHeader from "../../admin/pageHeader/pageheader";

function ClientTask() {
  const [isLoading, setIsLoading] = useState(false);
  const [TaskData, setTaskData] = useState<any>();
  const [meta, setMeta] = useState<any>({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1505);
  const { id } = useParams();

  const navigate = useNavigate();

  const columns = [
    {
      dataIndex: "TaskName",
      title: "Task Name",
    },
    {
      dataIndex: "descriptions",
      title: "Description",
    },
    {
      dataIndex: "status",
      title: "Status",
    },
    {
      dataIndex: "hourss",
      title: "hours",
    },
    {
      dataIndex: "minituess",
      title: "minitues",
    },
    {
      title: "Chat with Us",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Client/task_details/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];
  useEffect(() => {
    viewTaskData(page, pageSize);
  }, [page, pageSize]);

  const viewTaskData = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: "string",
        page: page,
        take: take,
        Projectid: Number(id),
      };
      const url = API.TASK_IN_PROJECT;
      const response: any = await POST(url, obj);
      setTaskData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageHeader />
      <Card>
        <h2 style={{ textAlign: "center" }}>Task Details</h2>
        <Table
          columns={columns}
          dataSource={TaskData}
          pagination={{
            defaultPageSize: 5, // Default number of rows per page
            showSizeChanger: true, // Allows user to change the number of rows per page
            pageSizeOptions: ["2", "10", "20", "50"], // Options for page size
          }}
        />
      </Card>
    </div>
  );
}

export default ClientTask;
